import "./comment.css";
import { Link } from "react-router-dom";

const Comment = ({username, timestamp, text }) => {
    return (
        <div className="comment">
            <div className="comment-header">
                <Link to={`/user/${username}`} className="username-text">{username}</Link>
                <span className="timestamp"> {timestamp}</span>
            </div>
            <p className="comment-text">{text}</p>
        </div>
    )
}

export default Comment;